module.exports = __webpack_public_path__ + "static/media/logo-white.ae45a04b.webp";